import { defaultTheme } from "@jjordy/layout"

export interface Theme {
  BASE_SIZE?: number
  rounded?: boolean
  UNIT?: string
  colors: {
    [color: string]: string
  }
}

export default Object.assign({}, defaultTheme, {
  BASE_SIZE: 1,
  rounded: true,
  UNIT: "rem",
  colors: {
    ...defaultTheme.colors,
    red: "#ED553B",
    success: "#4FB99F",
    primary: "#112F41",
    info: "#068587",
    yellow: "#F2B134"
  }
})

export const forCards = ["#ED553B", "#4FB99F", "#112F41", "#068587", "#F2B134"]
